import React from 'react'
import * as Sentry from '@sentry/react'
import ChunkErrorFallback from './ChunckErrorFallback'

function SentryErrorBoundary({ children, ...props }) {
  return (
    <Sentry.ErrorBoundary fallback={(args) => <ChunkErrorFallback {...args} />} {...props}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default SentryErrorBoundary
